import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=a81ce402&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=a81ce402&prod&lang=scss&scoped=true&"
import style1 from "./carousel.vue?vue&type=style&index=1&id=a81ce402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81ce402",
  null
  
)

export default component.exports